import { render, staticRenderFns } from "./PracticeTaxonomyCodes.vue?vue&type=template&id=c2d17e88&"
import script from "./PracticeTaxonomyCodes.vue?vue&type=script&lang=js&"
export * from "./PracticeTaxonomyCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports